import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataServiceService } from '../data-service.service';
import { ErrorService } from '../error.service';





@Component({
  selector: 'app-dvrdetailsdialog',
  templateUrl: './dvrdetailsdialog.component.html',
  styleUrls: ['./dvrdetailsdialog.component.scss']
})
export class DvrdetailsdialogComponent implements OnInit {
  showPassword: boolean = false;
  submitted = false;
  durationInSeconds = 3;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  myForm!: FormGroup;
  name: any;
  dvrdatalist: any;
  totaldvrdetails: any;
  showErrorForworkingDVR: boolean = false;

  constructor(public dialogRef: MatDialogRef<DvrdetailsdialogComponent>, private fb: FormBuilder, private _snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService, private dataService: DataServiceService, private errorService: ErrorService,) {

  }
  ngOnInit(): void {
    console.log('dialog-data', this.data);

    this.myForm = this.fb.group({
      buildingname: ['', Validators.required],
      ipAddress: ['', Validators.required],
      rtspPortNo: ['', Validators.required],
      httpPortNo: ['', Validators.required],
      userName: ['', Validators.required],
      password: ['', Validators.required],
      dvrModelNumber: ['', Validators.required],
      serialNumber: ['', Validators.required],
      maxNoOfChannels: ['', Validators.required],
      totalCamerasInstalled: ['0', Validators.required],
      totalWorkingCameras: ['0', Validators.required],
      rtspAuthentication: ['', Validators.required],
      imageFormat: ['1', Validators.required],
      dvrStatus: ['1', Validators.required]
      // view: [this.data?.view]

    });


    this.edit()
  }

  onClickpass() {

  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.submitted = true;
    const imagetosend = this.myForm.get('imageFormat')?.value === '1' ? 'JPEG' : 'NA';
    const dvrstatus = this.myForm.get('dvrStatus')?.value === '1' ? 'OPENED' : 'CLOSED';
    // if (this.myForm.valid) {
      var payload = {
        "buildingId": this.data.buildingId,
        "buildingName": this.myForm.value.buildingname,
        "campusId": this.data.campusId,
        "campusName": this.data.campusName,
        "cctvDetId": this.data.cctvDetId ? this.data.cctvDetId : 0,
        "cityId": this.data.cityId,
        "cityName": this.data.cityName,
        "dvrStatus": dvrstatus,
        "httpPortNo": this.myForm.value.httpPortNo,
        "imageFormat": imagetosend,
        "ipAddress": this.myForm.value.ipAddress,
        "maxNoOfChannels": this.myForm.value.maxNoOfChannels,
        "modelNo": this.myForm.value.dvrModelNumber,
        "password": this.myForm.value.password,
        "rtspAuthentication": this.myForm.value.rtspAuthentication,
        "rtspPortNo": this.myForm.value.rtspPortNo,
        "serialNo": this.myForm.value.serialNumber,
        "stateId": this.data.stateId,
        "stateName": this.data.stateName,
        "totalCamerasInstalled": this.myForm.value.totalCamerasInstalled,
        "totalWorkingCameras": this.myForm.value.totalWorkingCameras,
        "userName": this.myForm.value.userName,
        "buildingFusionCode": this.data.orcFusionBuildingCode,
        "businessSegment": this.data.segmentType
      }
      console.log('payload', payload);
      this.spinner.show();
      if (confirm('Do you want to save DVR Details')) {
        this.dataService.Adddvrsave(payload).subscribe(
          {
            next: (res) => {
              this.totaldvrdetails = res;
              this.spinner.hide();
              this.dialogRef.close('save');
              console.log('DVR_SAVE', this.totaldvrdetails);
              // Show success message
              this._snackBar.open(this.totaldvrdetails.message, '', {
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
                duration: this.durationInSeconds * 1000,
                panelClass: 'app-notification-success',
              });
            },
            error: (error) => {
              this.spinner.hide();
              console.log('error', error);
              this.errorService.errorDisplay(Number(error.status), 'Error', error.error.message);
            }
          }
        )

      } else {
        this.spinner.hide();
      }



    // } 
    // else {
    //   this._snackBar.open('Please fill all input fields', '', {
    //     horizontalPosition: this.horizontalPosition,
    //     verticalPosition: this.verticalPosition,
    //     duration: this.durationInSeconds * 1000,
    //   });
    // }
  }
  onTotalworking(event: any) {
    const totalinstall = this.myForm?.value?.totalCamerasInstalled;
    const totalworking = this.myForm?.value?.totalWorkingCameras;
    if (Number(totalinstall) < Number(totalworking)) {
      this.showErrorForworkingDVR = true;
    } else {
      this.showErrorForworkingDVR = false;
    }
  }

  edit() {
    this.myForm.patchValue({
      buildingname: this.data.buildingName,
      ipAddress: this.data.ipAddress,
      rtspPortNo: this.data.rtspPortNo,
      httpPortNo: this.data.httpPortNo,
      userName: this.data.userName,
      password: this.data.password,
      dvrModelNumber: this.data.dvrModelNumber,
      serialNumber: this.data.serialNumber,
      maxNoOfChannels: this.data.maxNoOfChannels,
      totalCamerasInstalled: this.data.totalCamerasInstalled,
      totalWorkingCameras: this.data.totalWorkingCameras,
      rtspAuthentication: this.data.rtspAuthentication,

    })
  }


}
